<script setup lang="ts">
import { setErrors, clearErrors } from '@formkit/core'

const runtimeConfig = useRuntimeConfig()
const emit = defineEmits(['submit'])
interface Submit {
  storefrontUrl: string,
  email: string
}
const submit = async (data: Submit) => {
  data.storefrontUrl = runtimeConfig.public.storefrontUrl
  clearErrors('recovery-form')
  try {
    await useFetch('/store-api/account/recovery-password', {
      method: 'POST',
      body: data
    })
    emit('submit', true)
  } catch (e) {
    setErrors(
      'recovery-form',
      JSON.stringify(e)
    )
  }
}
</script>

<template>
  <FormKit
    type="form"
    id="recovery-form"
    :actions="false" 
    :incomplete-message="false"
    @submit="submit"
  >
    <FormKit
      type="email"
      outer-class="mb-[10px]"
      name="email"
      label="E-mail*"
      placeholder="E-mail*"
      validation="required"
      validation-visibility="blur"
      :validation-messages="{
        required: 'Pole e-mail nie może być puste.'
      }"
    />
    <div class="text-gray-500 text-12">
      * Pole wymagane
    </div>
    <FormKit
      type="submit"
      input-class="btn btn-action btn-lg mb-[10px]"
    >
      <span class="text-16">Wyślij link ze zmianą hasła</span>
      <i class="icon-arrow-button text-[10px]" />
    </FormKit>
  </FormKit>
</template>
